export interface AppConfig {
  REACT_APP_CLIENT_ID: string;
  REACT_APP_ISSUER: string;
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_NAME: string;
}

let appConfig: AppConfig | null = null;

export const loadConfig = async (url: string): Promise<void> => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to load config: ${response.status}`);
  appConfig = (await response.json()) as AppConfig;
};

export const getConfig = (): AppConfig => {
  if (!appConfig) throw new Error('Config has not been loaded');
  return appConfig;
};
